import styled from "@emotion/styled";

export const StyledPopOverContent = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${(props) => props.theme.palette.background.default};
  box-shadow:
    0px 3px 15px 0px rgba(0, 0, 0, 0.15),
    0px 3px 15px 0px rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px;
  margin-top: 4px;
`;
